import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import clsx from 'clsx';
import { contrastColor, numStringToCss, prop } from '@bit/daviidli.corn-ui.utils';
const generatePositioning = (pos, offset, tip = false) => {
    if (pos.startsWith('top') || pos.startsWith('bottom')) {
        const vertical = pos.startsWith('top')
            ? css `
				bottom: ${tip ? `calc(100% + ${offset} - 16px)` : `calc(100% + ${offset})`};
			`
            : css `
				top: ${tip ? `calc(100% + ${offset} - 16px)` : `calc(100% + ${offset})`};
			`;
        if (pos.endsWith('Left')) {
            return css `
			${vertical}
			left: ${tip ? '0' : '-8px'};
		`;
        }
        if (pos.endsWith('Middle')) {
            return css `
				${vertical}
				left: 50%;
				transform: translateX(-50%);
			`;
        }
        return css `
			${vertical}
			right: ${tip ? '0' : '-8px'};
		`;
    }
    if (pos.startsWith('left') || pos.startsWith('right')) {
        const vertical = pos.startsWith('left')
            ? css `
				right: ${tip ? `calc(100% + ${offset} - 16px)` : `calc(100% + ${offset})`};
			`
            : css `
				left: ${tip ? `calc(100% + ${offset} - 16px)` : `calc(100% + ${offset})`};
			`;
        if (pos.endsWith('Top')) {
            return css `
				${vertical}
				top: ${tip ? '0' : '-8px'};
			`;
        }
        if (pos.endsWith('Middle')) {
            return css `
				${vertical}
				bottom: 50%;
				transform: translateY(50%);
			`;
        }
        return css `
			${vertical}
			bottom: ${tip ? '0' : '-8px'};
		`;
    }
    return '';
};
const Tip = styled.div `
	transition: all 0.3s ease;
	position: relative;
	display: inline-block;
	width: ${p => (p.FullWidth ? '100%' : 'auto')};

	&::before {
		content: '';
		opacity: ${p => (p.Shown ? '1' : '0')};
		transition: all 0.3s ease;
		z-index: ${p => (p.Shown ? '1' : '-1')};
		position: absolute;
		border-width: 8px;
		border-style: solid;
		border-color: ${p => {
    if (p.Position.startsWith('top'))
        return `${p.Color} rgba(0, 0, 0, 0) rgba(0, 0, 0, 0) rgba(0, 0, 0, 0)`;
    if (p.Position.startsWith('bottom'))
        return `rgba(0, 0, 0, 0) rgba(0, 0, 0, 0) ${p.Color} rgba(0, 0, 0, 0)`;
    if (p.Position.startsWith('left'))
        return `rgba(0, 0, 0, 0) rgba(0, 0, 0, 0) rgba(0, 0, 0, 0) ${p.Color}`;
    return `rgba(0, 0, 0, 0) ${p.Color} rgba(0, 0, 0, 0) rgba(0, 0, 0, 0)`;
}};
		${p => generatePositioning(p.Position, p.Offset, true)}
	}

	&::after {
		content: '${prop('Content')}';
		font-size: 0.85em;
		position: absolute;
		background-color: ${prop('Color')};
		padding: 0.5rem;
		border-radius: 6px;
		color: ${prop('TextColor')};
		opacity: ${p => (p.Shown ? '1' : '0')};
		transition: all 0.3s ease;
		z-index: ${p => (p.Shown ? '1' : '-1')};
		width: ${prop('Width')};
		${p => generatePositioning(p.Position, p.Offset)}
	}
`;
const Tooltip = (props) => {
    const { content, children, position, color, textColor, width, fullWidth, offset, className } = props;
    const [hovering, setHovering] = useState(false);
    return (React.createElement(Tip, { className: clsx('corn-tooltip', className), Position: position, Content: content, Color: color, TextColor: textColor || contrastColor(color, '#fff', '#000'), Shown: hovering, Width: numStringToCss(width), FullWidth: fullWidth, Offset: numStringToCss(offset) },
        React.createElement("div", { className: "corn-tooltip-container", onMouseEnter: () => setHovering(true), onMouseLeave: () => setHovering(false), onTouchStart: () => setHovering(true), onTouchEnd: () => setHovering(false) }, children)));
};
Tooltip.propTypes = {
    content: PropTypes.string.isRequired,
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
    position: PropTypes.oneOf([
        'topLeft', 'topMiddle', 'topRight',
        'leftTop', 'leftMiddle', 'leftBottom',
        'rightTop', 'rightMiddle', 'rightBottom',
        'bottomLeft', 'bottomMiddle', 'bottomRight'
    ]),
    color: PropTypes.string,
    textColor: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    fullWidth: PropTypes.bool,
    offset: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    className: PropTypes.string
};
Tooltip.defaultProps = {
    position: 'topMiddle',
    color: '#000',
    width: 'auto',
    fullWidth: false,
    offset: 16
};
export default Tooltip;
